// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { DiseaseCodeApi } from '../types/disease-code.types';
import { diseaseCodeHttpApi } from './disease-code.api';
import { diseaseCodeMockApi } from './disease-code.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const diseaseCodeApi: DiseaseCodeApi = useMock
  ? diseaseCodeMockApi
  : diseaseCodeHttpApi;
